import type { Product } from '../types'

export type ProductRelationType = 'similar' | 'associated'

export interface ProductRelationSection {
  label: string
  hint: string
  enabledKey: string
  titleKey: string
  defaultTitle: string
  /** Field filled by `GET /products/:slug` when the section is on. */
  productField: 'relatedProducts' | 'complementaryProducts'
}

/** Storefront order: complementary products first, similar ones after. */
export const PRODUCT_RELATION_TYPES: ProductRelationType[] = ['associated', 'similar']

/** `enabledKey` mirrors the backend `PRODUCT_RELATION_ENABLED_KEYS` (checked by `productRelations.test.ts`). */
export const PRODUCT_RELATION_SECTIONS: Record<ProductRelationType, ProductRelationSection> = {
  associated: {
    label: 'Produse complementare',
    hint: 'Accesorii sau produse care se cumpără împreună cu acesta.',
    enabledKey: 'product_relations_associated_enabled',
    titleKey: 'product_relations_associated_title',
    defaultTitle: 'Produse complementare',
    productField: 'complementaryProducts',
  },
  similar: {
    label: 'Produse similare',
    hint: 'Alternative pe care clientul le poate alege în locul acestui produs.',
    enabledKey: 'product_relations_similar_enabled',
    titleKey: 'product_relations_similar_title',
    defaultTitle: 'Produse similare',
    productField: 'relatedProducts',
  },
}

export const PRODUCT_RELATION_LIMIT = 24

export type AdminRelatedProduct = Pick<Product, 'id' | 'name' | 'slug' | 'sku' | 'price' | 'salePrice' | 'isActive' | 'images'>

export function productRelationTitle(type: ProductRelationType, settings: Record<string, string | undefined>): string {
  const section = PRODUCT_RELATION_SECTIONS[type]
  return settings[section.titleKey]?.trim() || section.defaultTitle
}
